const bankIconAssets = {
  barclays: "/bank-icons/barclays.svg",
  "co-operative": "/bank-icons/co-operative.svg",
  coutts: "/bank-icons/coutts.svg",
  firstdirect: "/bank-icons/firstdirect.svg",
  halifax: "/bank-icons/halifax.svg",
  hsbc: "/bank-icons/hsbc.svg",
  lloyds: "/bank-icons/lloyds.svg",
  "metro-bank": "/bank-icons/metro-bank.svg",
  monzo: "/bank-icons/monzo.svg",
  "national-westminster": "/bank-icons/national-westminster.svg",
  nationwide: "/bank-icons/nationwide.svg",
  "royal-bank-of-scotland": "/bank-icons/royal-bank-of-scotland.svg",
  santander: "/bank-icons/santander.svg",
  starling: "/bank-icons/starling.svg",
  tsb: "/bank-icons/tsb.svg",
  yorkshire: "/bank-icons/yorkshire.svg",
};

const bankNameMappings = {
  cooperative: "co-operative",
  metrobank: "metro-bank",
  natwest: "national-westminster",
  rbs: "royal-bank-of-scotland",
};

const getBankIcon = (bankName) => {
  if (!bankName) {
    return undefined;
  }

  let normalisedName = bankName.toLowerCase().replace(/\s/g, "-");
  normalisedName = bankNameMappings[normalisedName] || normalisedName;

  if (
    normalisedName.indexOf("lloyds") === -1 ||
    normalisedName.indexOf("tsb") === -1
  ) {
    return bankIconAssets[
      Object.keys(bankIconAssets).find((k) => normalisedName.includes(k))
    ];
  }

  return undefined;
};

export default getBankIcon;
